import React from 'react';
import update from 'immutability-helper';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import LeasePriceOverrideEditor from './LeasePriceOverrideEditor.js';
import MakeModelVariantField from '../misc/MakeModelVariantField.js';

class LeaseComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handlePriceAdvanceChange = this.handlePriceAdvanceChange.bind(this);
    this.handleMakeModelVariantChange = this.handleMakeModelVariantChange.bind(this);
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleMakeModelVariantChange(selections) {
    const change = {
      lease: {}
    };

    change.lease['make'] = {
      $set: selections.make
    };
    change.lease['model'] = {
      $set: selections.model
    };
    change.lease['variant'] = {
      $set: selections.variant
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleAssetChange(name, asset) {
    const change = {
      lease: {}
    };

    change.lease[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    return this.handleAssetChange(e.target.name, e.target.value);
  }

  handlePriceAdvanceChange(values) {
    const change = {
      lease: {}
    };

    change.lease.prices = {
      $set: values.prices
    };

    change.lease.advances = {
      $set: values.advances
    };

    const props = update(this.props, change);
    this.props.onChange(props);
  }

  render() {
    const lease = this.props.lease;

    let mmvCls = 'success';
    if (!lease.make) {
      mmvCls = 'danger';
    } else if (lease.model) {
      if (!lease.model.published) {
        mmvCls = 'warning';
      } else if (lease.model.updated) {
        mmvCls = 'info';
      }
      if (lease.variant) {
        if (!lease.variant.published) {
          mmvCls = 'warning';
        } else if (lease.variant.updated) {
          mmvCls = 'info';
        }
      }
    }

    return (
      <section className="mf-equipment-equipment">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/leases/">Lease</Link></li>
          {
          // <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
          // <li>
          //   <Link to={`/modeller/${lease.model.make.id}`}>{lease.model.make.name}</Link>
          // </li>
          // <li>
          //   <Link to={`/modeller/${lease.model.make.id}/modell/${lease.model.id}`}>{lease.model.name}</Link>
          // </li>
          }
          <li className="active">{lease.name}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>
                  {lease.name} <PublishStatusDot entry={lease} /><br/>
                  <small>Lease</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!lease.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    <span>Lagre endringer</span>
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={!(lease.draft || lease.updated) || this.props.working || this.props.modified || lease.archived}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={lease.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {!lease.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                &nbsp;
                {lease.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnarchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Navn</label>
                <input type="text" className="form-control" name="name" disabled={this.props.working || lease.archived} placeholder={lease.name} defaultValue={lease.name} onChange={this.handleFieldChange} />
              </div>
              <div className="form-group">
                <label>Leieperiode <small>I måneder</small></label>
                <input type="number" min="0" max="9999" className="form-control" name="term" disabled={this.props.working || lease.archived} placeholder={lease.term} defaultValue={lease.term} onChange={this.handleFieldChange} />
              </div>
              <div className="form-group">
                <label>Årlig kjørelengde <small>I km</small></label>
                <input type="number" min="0" className="form-control" name="range" disabled={this.props.working || lease.archived} placeholder={lease.range} defaultValue={lease.range} onChange={this.handleFieldChange} />
              </div>
              <div className="form-group">
                <label>Startleie</label>
                <input type="number" min="0" className="form-control" name="advance" disabled={this.props.working || lease.archived} placeholder={lease.advance} defaultValue={lease.advance} onChange={this.handleFieldChange} />
              </div>
              <div className="form-group">
                <label>Månedspris</label>
                <input type="number" min="0" className="form-control" name="price" disabled={this.props.working || lease.archived} placeholder={lease.price} defaultValue={lease.price} onChange={this.handleFieldChange} />
              </div>
              <div className="form-group">
                <label>Etableringsgebyr</label>
                <input type="number" min="0" className="form-control" name="arrangementFee" disabled={this.props.working || lease.archived} placeholder={lease.arrangementFee} defaultValue={lease.arrangementFee} onChange={this.handleFieldChange} />
              </div>
              <div className="form-group">
                <label>Rente</label>
                <input type="number" min="0" step="0.01" className="form-control" name="interest" disabled={this.props.working || lease.archived} placeholder={lease.interest} defaultValue={lease.interest} onChange={this.handleFieldChange} />
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              <MakeModelVariantField
                onChange={this.handleMakeModelVariantChange}
                cls={mmvCls}
                disabled={this.props.working || lease.archived}
                value={{
                  make: lease.make || null,
                  model: lease.model || null,
                  variant: lease.variant || null
                }}
              />
              <div className="form-group">
                <label>Leasingvilkår / ekstra informasjon</label>
                <textarea className="form-control" disabled={this.props.working || lease.archived} name="info" defaultValue={lease.info} onChange={this.handleFieldChange}/>
              </div>
              {lease.variant &&
                <div className="form-group">
                  <label>&quot;Frakt og levering&quot; tekst</label>
                  <span className="help-block">Vises tilknyttet prisen for å informere om prisen er eks. eller ink. frakt og levering</span>
                  <textarea className="form-control" name="shipmentText" disabled={this.props.working || lease.archived} defaultValue={lease.shipmentText} onChange={this.handleFieldChange}/>
                </div>
              }
            </div>
            <div className="col-xs-12 col-md-8">
              <div className="form-group">
                <label>Priser</label>
                <span className="help-block">Overstyring av priser per forhandler basert på tags</span>
                <LeasePriceOverrideEditor
                  disabled={lease.archived}
                  prices={lease.prices}
                  advances={lease.advances}
                  name="prices"
                  onSave={this.handlePriceAdvanceChange}
                  tags={this.props.tags}
                />
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default LeaseComponent;
